import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Import Api files
import {
  addPersonnelApi,
  deletePersonnelApi,
  editPersonnelApi,
  getPersonnelsApi,
  getSinglePersonnelApi,
} from "api/personnels";

// Login Redux States
import {
  ADD_PERSONNEL,
  DELETE_PERSONNEL,
  EDIT_PERSONNEL,
  GET_PERSONNELS,
  GET_SINGLE_PERSONNEL,
} from "./actionTypes";
import {
  addPersonnelFailure,
  addPersonnelSuccess,
  deletePersonnelFailure,
  deletePersonnelSuccess,
  editPersonnelFailure,
  editPersonnelSuccess,
  getPersonnelsFailure,
  getPersonnelsSuccess,
  getSinglePersonnelFailure,
  getSinglePersonnelSuccess,
} from "./actions";

function* getPersonnels() {
  try {
    const { data } = yield call(getPersonnelsApi);
    yield put(getPersonnelsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getPersonnelsFailure(error?.response?.data?.errors?.[0]?.msg));
  }
}

function* getSinglePersonnel({ payload }) {
  try {
    const { data } = yield call(getSinglePersonnelApi, payload);
    yield put(getSinglePersonnelSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(
      getSinglePersonnelFailure(error.response?.data?.message || error)
    );
  }
}

function* addPersonnel({ payload }) {
  try {
    const { data } = yield call(addPersonnelApi, payload.data);
    yield put(addPersonnelSuccess(data));
    console.log('data added')
    yield payload.navigate("/personnels");
  } catch (error) {
    console.log(error);
    yield put(addPersonnelFailure(error.response?.data?.message || error));
  }
}

function* editPersonnel({ payload }) {
  try {
    yield call(editPersonnelApi, payload);
    yield put(editPersonnelSuccess(payload));
    yield payload.navigate("/personnels");
  } catch (error) {
    console.log(error);
    yield put(editPersonnelFailure(error?.response?.data || error));
  }
}

function* deletePersonnel({ payload }) {
  try {
    yield call(deletePersonnelApi, payload);
    yield put(deletePersonnelSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deletePersonnelFailure(error?.response?.data || error));
  }
}

export function* watchGetPersonnels() {
  yield takeEvery(GET_PERSONNELS, getPersonnels);
}

export function* watchSinglePersonnel() {
  yield takeEvery(GET_SINGLE_PERSONNEL, getSinglePersonnel);
}

export function* watchAddPersonnel() {
  yield takeEvery(ADD_PERSONNEL, addPersonnel);
}

export function* watchEditPersonnel() {
  yield takeEvery(EDIT_PERSONNEL, editPersonnel);
}

export function* watchDeletePersonnel() {
  yield takeEvery(DELETE_PERSONNEL, deletePersonnel);
}

function* countriesSaga() {
  yield all([fork(watchGetPersonnels)]);
  yield all([fork(watchSinglePersonnel)]);
  yield all([fork(watchAddPersonnel)]);
  yield all([fork(watchEditPersonnel)]);
  yield all([fork(watchDeletePersonnel)]);
}

export default countriesSaga;
